<template>
    <div class="admin_box" id="admin_box">
        <div class="b_top">
            <!--顶部导航-->
            <top_menu></top_menu>
        </div>
        <div class="b_bot">
            <div class="menu">
                <!--左边菜单，管理员身份展示-->
                <el-menu v-if="isAdmin" class="my_el_menu" :collapse="menuState" :default-active="thisMenu"
                    :active="thisMenu" @select="menuClick" background-color="#F5F6F7" text-color="#363b4c"
                    active-text-color="#1e6fff">
                    <tree_menu :data="menuTree"></tree_menu>
                </el-menu>
            </div>
            <div class="view_main scroll-bar" id="view_main">
                <!--页面主体-->
                <div class="tabs-container">
                    <el-tabs v-if="isAdmin" v-model="thisMenu" @contextmenu.prevent.native="openContextMenu"
                        id="menuTab" @tab-remove="removeTab" class="custom-tabs">
                        <el-tab-pane v-for="(item, index) in openMenu" :key="item.id" :label="item.name"
                            :name="item.id">
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="view" :class="{ 'no-margin': !isAdmin }">
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive" class="router"></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive" class="router"></router-view>
                </div>
            </div>
        </div>
        <topMenu ref="rightTab" v-bind="rightTab"></topMenu>
    </div>
</template>

<script>
import * as c from '@/utils/config'
import * as u from '@/utils/util'

var elementResizeDetectorMaker = require("element-resize-detector")
export default {
    name: "admin",
    components: {
        'tree_menu': () => import('@/components/menu/tree_menu.vue'),
        'top_menu': () => import('@/components/topMenu/index.vue'),
        'topMenu': () => import('@/components/rightTab/topMenu.vue'),
    },
    watch: {
        //监听菜单状态变化
        menuState: function (val) {
            //存入session
            u.setSession(c.sessionKey.MENU_STATE, val);
        },
        $route: {
            handler: function (val, oldVal) {
                console.log(val);
                //判断切换的是否是首页
                // if (c.HOME_PAGE.path === val.path) {
                //     this.menuClick(c.HOME_PAGE.id);
                // } else {
                    //获取当前要切换路由的菜单对象
                    let menu = this.menuList.filter(x => x.path === val.path)[0];
                    this.menuClick(menu.id);
                // }
            },
            // 深度观察监听
            deep: true
        },
        //监听菜单切换
        thisMenu: function (val) {
            const targetMenu = this.openMenu.filter(x => x.id === val)[0];
            if (targetMenu && targetMenu.path && this.$route.path !== targetMenu.path) { //切换到不同路由才进行路由切换
                this.openUrl = targetMenu.path;
                this.$router.push(this.openUrl)
            }
        }
    },
    computed: {
        //打开过的菜单
        openMenu() {
            return this.$store.state.menuTab.openMenu
        },
        thisMenu: {
            get() {
                return this.$store.state.menuTab.thisMenu;
            },
            set(value) {
                this.$store.commit("setThisMenu", value);
            }
        },
        //判断是否是普通用户页面
        isMyFileTreePage() {
            return !this.isAdmin;
        },

    },
    data() {
        return {
            //菜单状态
            menuState: u.getSession(c.sessionKey.MENU_STATE) ? u.getSession(c.sessionKey.MENU_STATE) : false,
         
            //打开的路径
            openUrl: c.HOME_PAGE.path,
            //用户信息
            userInfo: u.getSession(c.sessionKey.USER_INFO),
            //菜单集合
            menuTree: u.getSession(c.sessionKey.SYS_MENU_TREE),
            menuList: [],
            //菜单树参数对应配置
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            //监听右键tab弹窗状态
            rightTab: {
                show: false,
                top: 0,
                left: 0,
                menu: null,
            },
            isAdmin: false,
         }
    },
    created() {
        this.traverseMenuTree(this.menuTree);

    },
    mounted() {
        //判断是否是管理员角色
        this.isAdmin = this.userInfo.roles.includes("149");
        
        // 如果 session 中没有保存菜单状态，则根据 isAdmin 来决定初始状态
        if (u.getSession(c.sessionKey.MENU_STATE) === null) {
            this.menuState = this.isAdmin; // 管理员默认展开(false)，非管理员默认折叠(true)
        }
        
        // 如果没有打开任何菜单，默认打开 /file/myFileTree 页面
        if (this.openMenu.length === 0) {
            // 从菜单树中找到 /file/myFileTree 对应的菜单项
            const defaultMenu = this.menuList.find(x => x.path === '/file/myFileTree');
            if (defaultMenu) {
                // 添加到 openMenu 并设置为当前激活菜单
                this.$store.commit("addOpenMenu", defaultMenu);
                this.$store.commit("setThisMenu", defaultMenu.id);
                // 跳转到该页面
                this.$router.push({ path: "/file/myFileTree" });
            }
        }
        
        this.$nextTick(() => {
            this.initDom();
        })
        elementResizeDetectorMaker().listenTo(document.getElementById("admin_box"), element => {
            // 重置图表
            this.$nextTick(() => {
                this.initDom();
            })
        })
    },
    methods: {
        openContextMenu: function (e) {
            e.preventDefault(); //防止默认菜单弹出
            let obj = e.srcElement ? e.srcElement : e.target;
            if (obj.id) {
                //获取菜单id
                let menuId = obj.id.split("tab-")[1];
                if (menuId === this.thisMenu) {
                    //找到当前全中的标签
                    let menu = this.openMenu.filter(x => x.id === menuId)[0];
                    this.rightTab.left = e.clientX;
                    this.rightTab.top = e.clientY + 10;
                    this.$refs.rightTab.openDia(menu);
                }

            }
        },

        //编辑菜单树
        traverseMenuTree(tree) {
            tree.forEach(x => {
                if (x.children != null && x.children.length > 0) {
                    this.traverseMenuTree(x.children);
                }
                this.menuList.push(x);
            })
        },

        //菜单点击事件
        menuClick(key) {
            this.$store.commit("setThisMenu", key);
            //判断当前节点是否已经加入openMenu;
            if (this.openMenu.filter(x => x.id === key).length === 0) {
                this.$store.commit("addOpenMenu", this.traverseTreeMenu(this.menuTree, key));

            }
        },

        //遍历找到菜单树找到当前指定菜单
        traverseTreeMenu(list, id) {
            let row;
            for (let i = 0; i < list.length; i++) {
                if (list[i].children != null && list[i].children.length !== 0) {
                    row = this.traverseTreeMenu(list[i].children, id)
                    if (row != null) {
                        return row;
                    }
                }
                if (id === list[i].id) {
                    row = list[i];
                }
            }
            return row;
        },

        //下拉菜单触发时间
        handleCommand(command) {
            switch (command) {
                case 'userInfo':
                    break
                case 'logout':
                    this.$confirm('是否确认退出登录?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        console.log('用户确认退出登录');
                        // 创建一个 Promise 来等待记录结束时间完成
                        return new Promise((resolve) => {
                            console.log('发送 before-logout 事件');
                            // 通知所有组件记录结束时间，并传递回调函数
                            this.$root.$emit('before-logout', resolve);
                            
                            // 设置超时保护，最多等待 2 秒
                            setTimeout(() => {
                                console.log('超时保护触发，强制 resolve');
                                resolve();
                            }, 2000);
                        });
                    }).then(() => {
                        console.log('记录结束时间完成，开始执行退出登录');
                        // 记录结束时间完成后，执行退出登录
                        u.post("/sys-login/logout").then(res => {
                            u.clearSession();
                            this.$router.push('/login')
                        })
                    })
                    break
            }
        },
        //菜单隐藏显示
        unfold(val) {
            this.menuState = val;
        },

        /**
         * 删除一个tab
         * @param targetName
         */
        removeTab(delKey) {
            //找到需要删除的节点
            let delIndex = this.openMenu.findIndex(x => x.id === delKey);
            this.$store.commit("delOpenMenu", delIndex);
            //判断删除的id是否等于当前选择的id
            if (delKey === this.thisMenu) {
                if (delIndex >= this.openMenu.length) {
                    this.$store.commit("setThisMenu", this.openMenu[this.openMenu.length - 1].id);
                } else {
                    this.$store.commit("setThisMenu", this.openMenu[delIndex].id);
                }
            }
        },

        /**
         * 初始化domjie
         */
        initDom() {
            // DOM 可能因为路由切换 / v-if 尚未渲染而为 null，必须做保护
            const viewMainEl = document.getElementById("view_main");
            const menuTabEl = document.getElementById("menuTab");
            const viewEl = document.getElementById("view");
            if (!viewMainEl || !menuTabEl || !viewEl) {
                return;
            }
            const viewMain = viewMainEl.offsetHeight || 0;
            const menuTab = menuTabEl.offsetHeight || 0;
            viewEl.style.height = viewMain - menuTab - 50 + "px";
        }

    }
}
</script>

<style scoped lang="scss">
.admin_box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;


    .b_top {
        width: 100%;
        display: flex;
        color: #363b4c;
    }

    .b_bot {
        flex: 1;
        width: 100%;
        display: flex;

        .menu {
            height: 100%;
            background-color: #F5F6F7;

            ::v-deep .my_el_menu:not(.el-menu--collapse) {
                width: 226px;
                height: calc(100% - 50px);
                overflow: hidden auto;
            }

            .my_el_menu {
                border: 0px !important;
            }
        }

        .view_main {
            height: calc(100vh - 50px);
            flex: 1;
            display: flex;
            flex-direction: column;

            .view {

                width: 99%;
                margin: 0 auto;
                height: calc(100vh - 50px);
                // overflow-y: auto;
                overflow-x: hidden;

                &.no-margin {
                    margin: 0;

                    .router {
                        margin: 0;
                    }
                }

                .router {
                    width: 99%;
                    height: 100%;
                    margin: 0 auto;
                }
            }
        }
    }
}

.tabs-container {
    padding-left: 16px;
    // background-color: aqua;
}
</style>
